import React from 'react';
// @ts-expect-error ts-migrate(7016) FIXME: Try `npm install @types/chart.js` if it exists or ... Remove this comment to see the full error message
import Chart from 'chart.js';


function mergeArrays(a: any, b: any) {
    if (!a || a.length !== b.length) return b;
    for (let i = 0; i < b.length; ++i) {
        Object.assign(a[i], b[i]);
    }
    return a;
}

type Props = {
    width?: string | number;
    height?: string | number;
    labelKey?: string;
    datasets?: any[];
    colorKey?: string;
    data?: any[];
    horizontal?: boolean;
};

export default class BarChart extends React.PureComponent<Props> {
    static defaultProps = {
        width: 400,
        height: 400,
        colorKey: 'color',
        labelKey: 'label',
        valueKey: 'value',
        horizonta: false,
    }

    canvas: any;
    chart: any;

    componentDidMount() {
        const ctx = this.canvas.getContext('2d');
        this.chart = new Chart(ctx, {
            type: this.props.horizontal ? 'horizontalBar' : 'bar',
            options: {
                legend: {
                    display: false,
                },
                scales: {
                    [this.props.horizontal ? 'xAxes' : 'yAxes']: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                },
                tooltips: {
                    // mode: 'index',
                    // intersect: false,
                    callbacks: {
                        label: (tooltipItem: any) => `${tooltipItem.yLabel}: ${tooltipItem.xLabel}`, // todo: display formatted value instead?
                        title: () => null,
                    }
                },
            },
        });
        this.refresh();
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        if (prevProps.data !== this.props.data) {
            this.refresh();
        }
    }

    refresh = () => {
        if (this.props.data) {
            // @ts-expect-error ts-migrate(2538) FIXME: Type 'undefined' cannot be used as an index type.
            this.chart.data.labels = this.props.data.map((row: any) => row[this.props.labelKey]);

            this.chart.data.datasets = mergeArrays(this.chart.data.datasets, [{
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'valueKey' does not exist on type 'Readon... Remove this comment to see the full error message
                data: this.props.data.map((row: any) => row[this.props.valueKey]),
                // @ts-expect-error ts-migrate(2538) FIXME: Type 'undefined' cannot be used as an index type.
                backgroundColor: this.props.data.map((row: any) => row[this.props.colorKey]),

            }])
        }
        this.chart.update();
    };

    setCanvas = (n: any) => {
        this.canvas = n;
    };

    render() {
        const {width, height} = this.props;
        return (
            <canvas ref={this.setCanvas} style={{width, height}}/>
        )
    }
}
